import { KatBadge } from "@amzn/katal-react";
import classnames from "classnames";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  DEFAULT_TRANSLATION_CONFIG,
  DEFAULT_TRANSLATION_NS,
} from "src/components/TranslatedField/TranslationKey";
import styles from "src/styles.module.scss";

type MismatchCurrentErrorsBadgeProps = {
  currentErrors: number;
  totalErrors: number;
};

const MismatchCurrentErrorsBadge: FC<MismatchCurrentErrorsBadgeProps> = ({
  currentErrors,
  totalErrors,
}) => {
  const { t } = useTranslation(
    DEFAULT_TRANSLATION_NS,
    DEFAULT_TRANSLATION_CONFIG
  );

  return (
    <KatBadge
      className={classnames([
        styles.capitalizedText,
        styles.kat_component_border_radius_0,
      ])}
      label={t("aic_mismatch_current_errors_badge", {
        currentErrors: currentErrors,
        totalErrors: totalErrors,
      })}
    />
  );
};

export default MismatchCurrentErrorsBadge;
